import Vue from 'vue'
import Vuex from 'vuex'
import { getQueryStrings } from './util'

Vue.use(Vuex)

const urlQuery = getQueryStrings()

// 隐藏菜单。根据链接参数hideSideMenu 或者 session数据hideSideMenu
const hideSideMenu = 'hideSideMenu' in urlQuery || sessionStorage.getItem('hideSideMenu') === 'true'
const showSideMenu = 'showSideMenu' in urlQuery
hideSideMenu && sessionStorage.setItem('hideSideMenu', true)
showSideMenu && sessionStorage.removeItem('hideSideMenu')

// 获取融合生态标识
const mixScene = 'mixScene' in urlQuery ? urlQuery.mixScene : sessionStorage.getItem('mixScene')
mixScene && sessionStorage.setItem('mixScene', mixScene)

// 获取ep项目标识
const isPartner = 'isPartner' in urlQuery ? urlQuery.isPartner : sessionStorage.getItem('isPartner')
isPartner && sessionStorage.setItem('isPartner', true)

export default new Vuex.Store({
  state: {
    userInfo: {},
    isOrg: false,
    isH5: false,
    tsignData: {},
    hideSideMenu: hideSideMenu && !showSideMenu,
    mixScene,
    isPartner,
  },
  mutations: {
    setTsignData(state, data) {
      state.tsignData = data
    },
    setUserInfo(state, data) {
      state.userInfo = data
    },
    setIsOrg(state, data) {
      state.isOrg = data
    },
    setIsH5(state, data) {
      state.isH5 = data
    },
    setHideSideMenu(state, data) {
      state.hideSideMenu = data
      sessionStorage.setItem('hideSideMenu', data)
    },
    setIsPartner(state, data) {
      state.isPartner = data
      sessionStorage.setItem('isPartner', data)
    },
    setShowOrderBtn(state, data) {
      state.showOrderBtn = data
      sessionStorage.setItem('showOrderBtn', data)
    },
  },
  actions: {},
})
